export const OLD_DEFAULT_OS_BOARD_BG =
  'https://firebasestorage.googleapis.com/v0/b/officeparty-1cc24.appspot.com/o/lobby%2Fos-desktop%2Fdefault-background.png?alt=media&token=75721310-e896-4d74-b219-7fd933a48058';
export const NEW_DEFAULT_OS_BOARD_BG =
  'https://firebasestorage.googleapis.com/v0/b/officeparty-1cc24.appspot.com/o/lobby%2Fos-desktop%2Fdefault-background-v2.png?alt=media&token=61220e01-ecea-4779-b97b-05c7e0d2d1b5';
